import { FEATURES } from '@/src/constants/Text'

export const eventsOptionsRoutes = (showFeatures, user) => {
  const routes = [
    {
      name: 'events.prospect',
      title: 'Eventos',
      hasPermission: showFeatures[FEATURES.EVENTOS],
    },
    {
      name: 'events.manager',
      title: 'Configurações eventos',
      hasPermission:
        showFeatures[FEATURES.EVENTOS] && showFeatures[FEATURES.EVENTOS_GESTOR],
    },
  ]

  return routes.filter((route) => route.hasPermission)
}
